import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { NotificationManager } from "react-notifications";
import MainContainer from "../../layouts/container/mainContainer";
import { FormProvider, useForm } from "react-hook-form";
import "../../styles/pages/login.scss";
import Button from "../../components/buttons/button";
import Modal from "@mui/material/Modal";
import {
  callApi,
  saveChangeStep,
  getStepsProcess,
} from "../../services/apiService";
import AutocompleteSelect from "../../components/forms/inputsMui/autocomplete";

const ChangeStepModal = ({
  open,
  onClose,
  currentUser,
  loadDataTable,
  postulationIds,
  setCheckedPostulationIds,
}) => {
  const { t } = useTranslation();
  const [stepList, setStepList] = useState([]);

  const validations = {
    step: {
      required: { value: true, message: t("userList.required") },
    },
  };

  const defaultValues = {};
  const methods = useForm({ defaultValues });
  const {
    control,
    register,
    setValue,
    watch,
    handleSubmit,
    reset,
    formState: { errors },
  } = methods;

  const cleanForm = () => {
    setValue("step", "");
  };

  useEffect(() => {
    callApi(
      () => getStepsProcess(),
      (data) => {
        const translatedSteps = data.map((step) => ({
          ...step,
          name: t(step.name),
        }));

        setStepList(translatedSteps);
      }
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onSubmit = handleSubmit((data) => {
    const submitData = {
      stepId: parseInt(data.step),
      postulationIds: postulationIds,
    };
    callApi(
      () => saveChangeStep(submitData),
      () => {
        NotificationManager.success(t("form.success"));
        onCloseHandle();
        setCheckedPostulationIds([]);
        loadDataTable();
      }
    );
  });

  const onCloseHandle = () => {
    cleanForm();
    reset();
    onClose();
  };

  return (
    <>
      <Modal
        open={open}
        onClose={onCloseHandle}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <MainContainer class="ww-container-m" showImage={false}>
          <h1 style={{ margin: "20px 0 20px 0" }} className="title">
            {t("userList.stepChange")}
          </h1>
          <FormProvider {...methods}>
            <form>
              <div className="inputs-style">
                {currentUser && Object.keys(currentUser).length > 0 ? (
                  <>
                    <label>
                      {t("userList.changeStepLabel") +
                        " " +
                        currentUser.lastName +
                        " " +
                        currentUser.name +
                        ". " +
                        t("userList.currentStep") +
                        t(currentUser.statePostulationGeneralName)}
                    </label>
                  </>
                ) : (
                  <label>{t("userList.changesStepLabel")}</label>
                )}

                <AutocompleteSelect
                  name="step"
                  label={t("userList.steps")}
                  options={stepList}
                  register={register}
                  registerOptions={validations}
                  watch={watch}
                  setValue={setValue}
                />
                {watch("step") == "" && (
                  <span className="text-danger text-small d-block mb-2 validation-margin">
                    {errors.step && errors.step.message}
                  </span>
                )}
              </div>
            </form>
          </FormProvider>
          <div>
            <div className="table-btn-group">
              <Button
                type="ww-btn-secondary"
                style={{ margin: "10px" }}
                size="btn-s secondary"
                label={t("main.close")}
                onClick={() => {
                  cleanForm();
                  onCloseHandle();
                }}
              />
              <Button
                size="btn-s"
                label={t("main.send")}
                onClick={() => {
                  onSubmit();
                }}
              />
            </div>
          </div>
        </MainContainer>
      </Modal>
    </>
  );
};

export default ChangeStepModal;
